<div class="modal-header">
    <h5 class="modal-title">{{ description.id ? 'Edit' : 'Add' }} Physical Description</h5>
    <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="height">Height (cm)</label>
        <input type="number" class="form-control" id="height" [(ngModel)]="description.height" name="height">
      </div>
      <div class="form-group">
        <label for="width">Width (cm)</label>
        <input type="number" class="form-control" id="width" [(ngModel)]="description.width" name="width">
      </div>
      <div class="form-group">
        <label for="thickness">Thickness (cm)</label>
        <input type="number" class="form-control" id="thickness" [(ngModel)]="description.thickness" name="thickness">
      </div>
      <div class="form-group">
        <label for="weight">Weight (grams)</label>
        <input type="number" class="form-control" id="weight" [(ngModel)]="description.weight" name="weight">
      </div>
      <div class="form-group">
        <label for="pageCount">Page Count</label>
        <input type="number" class="form-control" id="pageCount" [(ngModel)]="description.pageCount" name="pageCount">
      </div>
      <div class="form-group">
        <label for="bindingType">Binding Type</label>
        <input type="text" class="form-control" id="bindingType" [(ngModel)]="description.bindingType" name="bindingType">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Cancel</button>
    <button type="button" class="btn btn-outline-primary" (click)="onSaveClick()">Save</button>
  </div>
  
